import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/layouts/default.vue").then(m => m.default || m))
}